// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2Xs99","filesListContainer":"PosDisputesFiles_filesListContainer__3ciyb","filesButton":"PosDisputesFiles_filesButton__hQx8a"};